<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="600px">
      <v-card dense>
        <v-toolbar elevation="0">
          <v-toolbar-title
            class="pl-3 text--subtitle error--text"
            style="text-transform: uppercase"
          >
            <v-icon color="error" style="padding-bottom: 2px"
              >mdi-folder-outline</v-icon
            >
            {{ $t('message.remove') }} {{ $t('message.folder') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="px-7 py-0">
          <v-row no-gutters>
            <v-col cols="12">
              {{ $t('message.confirmFolderRemove') }}
              <b>{{ folder.name }}</b
              >?
              <br />
              {{ $t('message.videosRemain') }}
            </v-col>
            <v-col cols="12" class="my-3">
              <b>{{ $t('message.pleaseConfirmRemove') }}</b>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="removeText"
                dense
                outlined
                autofocus
                :error="errors.deleteFolder"
                :messages="deleteFolderErrMsg"
                @keypress.enter="handleDelete"
              >
                <template v-slot:message="{ message }">
                  <span class="error--text caption" v-if="errors.deleteFolder">
                    <v-icon color="error" size="18"> mdi-alert-circle </v-icon>
                    {{ message }} {{ unknownErrorMsg }}
                  </span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pl-8 pr-7 pb-6">
          <v-spacer></v-spacer>
          <v-btn
            class="mr-4"
            text
            :disabled="isFetching || loadings.confirm"
            @click="handleClose"
          >
            {{ $t('message.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            @click="handleDelete"
            :loading="loadings.confirm"
            :disabled="!removeVerification || isFetching || loadings.confirm"
          >
            <span class="px-5">{{ $t('message.confirm') }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import foldersApi from '../../services/foldersApi'

export default {
  name: 'FolderDelete',
  components: {},
  data: () => ({
    open: false,
    isFetching: false,
    removeText: '',
    folder: {
      name: '',
    },
    folderId: '',
    loadings: {
      confirm: false,
    },
    errors: {
      deleteFolder: false,
    },
    unknownErrorMsg: '',
  }),
  computed: {
    removeVerification() {
      return (
        this.removeText.toUpperCase() ===
        this.$i18next.t('message.remove').toUpperCase()
      )
    },
    deleteFolderErrMsg() {
      if (this.errors.deleteFolder) {
        return (
          this.$i18next.t(
            'message.pages.folderDelete.errors.defaultDeleteErr'
          ) + this.unknownErrorMsg
        )
      }
      return ''
    },
  },
  mounted() {
    this.$root.$on('folderDelete', (folder) => {
      this.folder = {
        name: folder.name,
      }
      this.folderId = folder.id
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('folderDelete')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    ...mapActions('user', ['removeFolder']),
    async handleDelete() {
      this.clearErrors()
      if (!this.removeVerification) {
        return
      }
      this.loadings.confirm = true
      try {
        await foldersApi.deleteFolder(this.folderId)
        this.removeFolder(this.folderId)
      } catch (e) {
        const anyError = JSON.parse(JSON.stringify(e))
        if (anyError.message || anyError.status) {
          this.unknownErrorMsg = e.response.status
        }
        this.errors.deleteFolder = true
      }
      this.loadings.confirm = false
      this.handleClose()
    },
    clearErrors() {
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
    },
    handleClose() {
      this.removeText = ''
      this.open = false
    },
  },
}
</script>

<style></style>
